<bzg-sidebar-container>
  <bzg-sidebar-responsive-container>
  <bzg-sidebar [brandIcon]="'icon-bizagi-logo'">
    <bzg-sidebar-item [icon]="'icon-control'"
                      [routerLink]="['mc', defaultView]"
                      [title]="'GLOBAL.MANAGEMENTCONSOLE' | translate"
                      routerLinkActive
                      #mc="routerLinkActive"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="navigateDefaultView()"
                      [isActive]="viewConfig.currentMenu === 'mc'">
    </bzg-sidebar-item>
    <bzg-sidebar-footer [userFullName]="profile.name || profile.email" [triggerMenu]="triggerMenu">
      <bzg-sidebar-footer-item *ngIf="isAutoLoginAuthentication"
                              [title]="'GLOBAL.SETTINGS' | translate"
                              [icon]="'icon-gear'"
                              [routerLink]="'../settings'"
                              routerLinkActive
                              #settings="routerLinkActive"
                              [routerLinkActiveOptions]="{exact: true}"
                              (click)="settings.isActive = true"
      ></bzg-sidebar-footer-item>
      <!--<button type="button" class="bz-btn-icn bz-btn-icn&#45;&#45;24" >-->
      <!--<bzg-icon [nameIcon]="'icn-settings'"></bzg-icon>-->
      <!--</button>-->
      <bzg-menu  #triggerMenu [keepOnOverlayClick]="true" class="bmc-user-menu">
        <bzg-menu-item class="bmc-user-menu__user-info">
          <span>{{profile.name || profile.email}}</span>
        </bzg-menu-item>
        <bzg-menu-item class="bmc-user-menu__item">
          <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-information'"></bzg-icon>
          <a href="https://help.bizagi.com/bpm-suite/en/index.html?automation_mc.htm" target="_blank"
            class="bmc-user-menu__item__link" [ngClass]="_showServerTime ? 'float-menu__servertime-margin' : 'float-menu__servertime-without-margin'" >{{'GLOBAL.HELP' | translate}}</a>
        </bzg-menu-item>

        <bzg-menu-item style="display: flex;" [allowOverflow]="true" *ngIf="_showServerTime" >
          <bzg-icon class="float-menu__menu-item-icon" [nameIcon]="'icon-server-time'"></bzg-icon>
          <bzg-select class="float-menu__servertime-selector"
                      [placeholder]="placeHolderServerTime"
                      (valueChange)="resetApp($event)" #selectServerTime>
            <bzg-option [value]="'Business'" [ngClass]="serverTime === 'Business' ? 'selectedOptionServerTime' : 'noSelectedOptionServerTime'">{{'GLOBAL.SERVER_TIME_BUSINESS' | translate}}</bzg-option>
            <bzg-option [value]="'Local'" [ngClass]="serverTime === 'Local' ? 'selectedOptionServerTime' : 'noSelectedOptionServerTime'">{{'GLOBAL.SERVER_TIME_LOCAL' | translate}}</bzg-option>
            <bzg-option [value]="'UTC'" [ngClass]="serverTime === 'UTC' ? 'selectedOptionServerTime' : 'noSelectedOptionServerTime'">{{'GLOBAL.SERVER_TIME_UTC' | translate}}</bzg-option>
          </bzg-select>
        </bzg-menu-item>

        <bzg-menu-item (click)="logout()" class="bmc-user-menu__item">
          <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-logout'"></bzg-icon>
          <a class="bmc-user-menu__item__link" [ngClass]="_showServerTime ? 'float-menu__servertime-margin' : 'float-menu__servertime-without-margin'">{{'GLOBAL.SIGN_OUT' | translate}}</a>
        </bzg-menu-item>

        <bzg-menu-item  class="bmc-user-menu__item">
          <span class="bmc-user-menu__item__link">{{'MENU.VERSION' | translate}}: {{mcVersion}}</span>
        </bzg-menu-item>
      </bzg-menu>


    </bzg-sidebar-footer>
  </bzg-sidebar>

  <router-outlet name="sidebar-panel" *ngIf="menuItems && menuItems.length > 0"></router-outlet>
  <!-- This router outlet will render a different sidebar panel for each of the sidebar items -->
</bzg-sidebar-responsive-container>


  <bzg-sidebar-content>
    <div class="bmc-sidebar-container">
      <bzg-sidebar-responsive-header [title]="'GLOBAL.MANAGEMENTCONSOLE' | translate"></bzg-sidebar-responsive-header>
      <div class="bmc-container" id="bmc-container">
        <div class="bmc-container__header bz-space--stack-s">
          <div class="bmc-container__project-context bz-space--stack-s">
            <div class="bmc-container__project-context__header">
              <div class="bmc-container__project-context__header__info-text">
                <span></span>
              </div>
              <h4 class="bz-font-weight--semibold bmc-container__title">{{viewConfig.currentView | translate}}</h4>
            </div>
            <div>
              <dynamic-component></dynamic-component>
            </div>
            <div class="bmc-container__environment" *ngIf="currentEnvironmentDisplayText">
              <label *ngIf="serverTime === 'UTC'" class="bmc-container__environment__text bmc-container__environment__text-utc">{{'GLOBAL.UTC_LABEL' | translate}}</label>
              <label *ngIf="serverTime !== 'UTC'" class="bmc-container__environment__text bmc-container__environment__text-utc">{{messageLocalTime}}</label>
              <bzg-icon [nameIcon]="iconEnvironment" [size]="22"></bzg-icon>
              <label class="bmc-container__environment__text">{{currentEnvironmentDisplayText | translate}}</label>
              <div class="bmc-container__environment__refresh">
                <bzg-button-icon (click)="reloadCurrentView()" class="bmc-container__environment__refresh__icon" icon="icon-refresh"></bzg-button-icon>
              </div>
            </div>
          </div>
            <div class="bmc-container__header__alert bz-space--inset-s bz-space--stack-s" *ngIf="showStudioAlert()">
                <bzg-icon class="bz-space--inline-m" [nameIcon]="'icon-warning'" [color]="'#272727'"></bzg-icon>
              {{'GLOBAL.BIZAGI_STUDIO_CHANGES_ALERT' | translate}}
            </div>
        </div>
        <router-outlet class="bmc-container__outlet" *ngIf="menuItems && menuItems.length > 0"></router-outlet>
        <bz-alert></bz-alert>
      </div>
    </div>
  </bzg-sidebar-content>
</bzg-sidebar-container>